import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';
import { SVG_COMPONENTS, SVG_DIMENSIONS } from '@/assets/admin';
import { ADMIN_COLORS } from '@/constants/admin';

interface DownloadButtonProps {
  onPress?: () => void;
  style?: ViewStyle;
  activeOpacity?: number;
  accessibilityLabel?: string;
  accessibilityHint?: string;
  iconColor?: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  onPress,
  style,
  activeOpacity = 0.8,
  accessibilityLabel = "Download",
  accessibilityHint = "Tap to download",
  iconColor = ADMIN_COLORS.TEXT.PRIMARY,
}) => {
  return (
    <TouchableOpacity
      style={[styles.downloadButton, style]}
      onPress={onPress}
      activeOpacity={activeOpacity}
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
      accessibilityRole="button"
    >
      <SVG_COMPONENTS.DOWNLOAD {...SVG_DIMENSIONS.DOWNLOAD} color={iconColor} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  downloadButton: {
    // Match the ADD_BUTTON styling from Figma
    width: 34,
    height: 34,
    paddingHorizontal: 8, // padding-left: 8px, padding-right: 8px
    paddingVertical: 0,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND, // Same red background as add button (#F55560)
    justifyContent: 'center',
    alignItems: 'center',
    // gap: 6px is handled by flexbox spacing if needed
  },
});
